import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["blockquote", "code-block"],
    ["link", "image"],
    [{ align: [] }],
    ["clean"],
  ],
};

const formats = [
  "header", "bold", "italic", "underline", "strike",
  "color", "background", "list", "bullet",
  "blockquote", "code-block", "link", "image", "align",
];

const HtmlEditor = ({ value, onChange, placeholder, minHeight = 220, testId }) => {
  return (
    <div data-testid={testId} className="rg-quill-wrap" style={{ minHeight }}>
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder || "Write here…"}
      />
      <style>{`
        .rg-quill-wrap .ql-toolbar {
          border-top-left-radius: 0.5rem;
          border-top-right-radius: 0.5rem;
          border-color: #e4e4e7;
          background: #fafafa;
        }
        .rg-quill-wrap .ql-container {
          border-bottom-left-radius: 0.5rem;
          border-bottom-right-radius: 0.5rem;
          border-color: #e4e4e7;
          font-family: 'Work Sans', system-ui, sans-serif;
          font-size: 14px;
          min-height: ${minHeight - 42}px;
        }
        .rg-quill-wrap .ql-editor { min-height: ${minHeight - 42}px; }
        .rg-quill-wrap .ql-snow .ql-stroke { stroke: #52525b; }
        .rg-quill-wrap .ql-snow .ql-fill { fill: #52525b; }
      `}</style>
    </div>
  );
};

export default HtmlEditor;
